(function () {
  var DUR_COUNT = 1800;
  var DUR_BAR = 1600;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ease = function (t) {
    return 1 - Math.pow(1 - t, 3);
  };
  var fmt = function (n) {
    return Math.round(n).toLocaleString('en-US');
  };

  function countUp(el) {
    var target = Number(el.dataset.count);
    var suffix = el.dataset.suffix || '';
    if (!isFinite(target)) return;
    if (reduce) {
      el.textContent = fmt(target) + suffix;
      return;
    }
    var start = performance.now();
    (function step(now) {
      var t = Math.min((now - start) / DUR_COUNT, 1);
      el.textContent = fmt(target * ease(t)) + suffix;
      if (t < 1) requestAnimationFrame(step);
    })(start);
  }

  function growBar(track) {
    var target = Number(track.dataset.target);
    if (!isFinite(target)) return;
    if (reduce) {
      track.style.setProperty('--as-level', target + '%');
      return;
    }
    var start = performance.now();
    (function step(now) {
      var t = Math.min((now - start) / DUR_BAR, 1);
      track.style.setProperty('--as-level', target * ease(t) + '%');
      if (t < 1) requestAnimationFrame(step);
    })(start);
  }

  function init(root) {
    var items = root.querySelectorAll('[data-count]:not([data-done]), [data-target]:not([data-done])');
    if (!items.length) return;
    var run = function (el) {
      el.setAttribute('data-done', '');
      if (el.hasAttribute('data-count')) countUp(el);
      else growBar(el);
    };
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(run);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            run(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }

  function boot() {
    document.querySelectorAll('[data-as-cause]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-as-cause]');
    if (!root) return;
    root.querySelectorAll('[data-done]').forEach(function (el) {
      el.removeAttribute('data-done');
    });
    init(root);
  });
})();
